import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "Settings"
    };
  }
});

function RouteComponent() {
  return <Outlet />;
}
